// Названия стадий из БД (на языке запроса) — по id и по коду.

import { useQuery } from "@tanstack/react-query";

import { stagesApi } from "./api";

export function useStageNames() {
  const q = useQuery({
    queryKey: ["stages", "names"],
    queryFn: () => stagesApi.list({ page_size: 200 }),
    staleTime: 5 * 60_000,
  });
  const items = q.data?.items ?? [];
  const byId = new Map(items.map((s) => [s.id, s.name ?? s.name_ru]));
  const byCode = new Map(items.map((s) => [s.code, s.name ?? s.name_ru]));
  return {
    byId: (id: number) => byId.get(id) ?? `#${id}`,
    byCode: (code: string) => byCode.get(code) ?? code,
  };
}
